import React from "react";
import styled from "styled-components";
import { Translation } from "../../../core/translate";
import { cloud } from "@vitalsource/vstui/colors";

const StyledBenefits = styled.div`
  margin-top: 21px;
`;

const Benefits = styled.div`
  margin: 8px 0 18px 0;
  display: flex;
  height: 150px;
  justify-content: space-between;
`;

const AccountDescription = styled.div`
  font-size: 1.4rem;
  font-weight: 500;
  padding: 0 3px 0 3px;
`;

const AccountBenefit = styled.div`
  width: 48%;
  font-size: 1.4rem;
  font-weight: 300;
  line-height: 1.29;
  height: 100%;
  & > div {
    background: ${cloud.getShade(3)};
    height: 100%;
    padding: 18px;
    .icon {
      width: 100%;
      height: 50px;
      margin-bottom: 10px;
      text-align: center;
      vertical-align: middle;
    }
  }
`;

export default () => (
  <StyledBenefits>
    <AccountDescription>
      <Translation id="sso.account-benefits">Account Benefits</Translation>
    </AccountDescription>
    <Benefits>
      <AccountBenefit>
        <div>
          <div className="icon">
            <img src="/img/sso_devices.svg" />
          </div>
          <div>
            <Translation id="sso.read-offline">Read Offline</Translation>
          </div>
        </div>
      </AccountBenefit>
      <AccountBenefit>
        <div>
          <div className="icon">
            <img src="/img/sso_sharing.svg" />
          </div>
          <div>
            <Translation id="sso.share-highlighters">
              Share Highlighters
            </Translation>
          </div>
        </div>
      </AccountBenefit>
    </Benefits>
  </StyledBenefits>
);
